import { render, staticRenderFns } from "./InboxTimer.vue?vue&type=template&id=b23f052c"
import script from "./InboxTimer.vue?vue&type=script&lang=js"
export * from "./InboxTimer.vue?vue&type=script&lang=js"
import style0 from "./InboxTimer.vue?vue&type=style&index=0&id=b23f052c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports